import { NumberField } from 'enova-frontend-components';
import { Control, Controller } from 'react-hook-form';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AboutFormData } from '../../types';
import { useAboutFormContext } from '../../utils';

interface Props {
  control: Control<AboutFormData>;
}

export const AreaField: FC<Props> = ({ control }) => {
  const { t } = useTranslation();
  const { trigger } = useAboutFormContext();

  return (
    <Controller
      control={control}
      name="bygginfo.area"
      rules={{
        validate: (value) => {
          if (!value || value === 0) {
            return t('register.errorMessage.field.totalBRA');
          }
        }
      }}
      render={({ field, fieldState: { error }, formState }) => {
        return (
          <NumberField
            required
            value={field.value}
            suffix={t('suffix.m2')}
            error={!!error}
            helperText={error && t(`${error.message}`)}
            onValueChange={({ floatValue }) => {
              field.onChange(floatValue || null);

              if (formState.isSubmitted) {
                trigger('bygginfo.heatedArea');
              }
            }}
            label={t('register.bygningsdetaljer.totalBRA.label')}
            HelperBoxProps={{
              'aria-label': t('readFieldInformation'),
              children: t('register.bygningsdetaljer.totalBRA.information')
            }}
          />
        );
      }}
    />
  );
};
